import {
  Box,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import useSeeds from "../../services/useSeeds";
import { ISeed } from "../../types/seed";
import { Link } from "react-router-dom";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { formatAddress } from "../../utils/addressUtils";

import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconAnchor: [12.5, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

const Seeds = () => {
  const { data: seeds, isLoading } = useSeeds();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const seedsWithAddress = seeds.filter(
    (seed: ISeed) =>
      seed.address &&
      seed.address.latitude !== undefined &&
      seed.address.latitude !== null &&
      seed.address.longitude !== undefined &&
      seed.address.longitude !== null,
  );

  const center: [number, number] = seedsWithAddress.length
    ? seedsWithAddress.reduce(
        (acc: [number, number], seed: ISeed, index: number) => {
          acc = [
            acc[0] + Number(seed.address!.latitude),
            acc[1] + Number(seed.address!.longitude),
          ];
          if (index === seedsWithAddress.length - 1) {
            acc = [
              acc[0] / seedsWithAddress.length,
              acc[1] / seedsWithAddress.length,
            ];
          }

          return acc;
        },
        [0, 0],
      )
    : [-30.0346, -51.2177];

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      {/* Lista de Sementes */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h5" component="h2" gutterBottom>
            Sementes Disponíveis
          </Typography>
          <List>
            {seedsWithAddress.map((seed: ISeed) => (
              <ListItem key={seed.slug} disablePadding>
                <ListItemButton component={Link} to={seed.slug}>
                  <ListItemText
                    primary={seed.name}
                    secondary={
                      seed.address
                        ? formatAddress(seed.address)
                        : "Endereço não disponível"
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>

      {/* Mapa */}
      <Box
        sx={{
          height: "60vh",
          width: "100%",
        }}
      >
        <MapContainer
          center={center}
          scrollWheelZoom={false}
          style={{ height: "100%", width: "100%" }}
          zoom={11}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {seedsWithAddress.map((seed: ISeed) => (
            <Marker
              key={seed.slug}
              position={[
                Number(seed.address!.latitude),
                Number(seed.address!.longitude),
              ]}
            >
              <Popup>
                <Link to={seed.slug}>
                  {seed.name} - {formatAddress(seed.address!)}
                </Link>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </Box>
    </Box>
  );
};

export default Seeds;
